<div class="autocomplete" #inputWrapper (click)="onInputClick()">

  <!-- Champ natif — ng-content directement ici pour que l'icône fonctionne -->
  <div class="ac-input-wrapper"
       [class.ac-input-wrapper--focused]="isFocused()">

    <span class="ac-input-icon">
      <ng-content select="[slot='icon-left']"></ng-content>
    </span>

    <input
      class="ac-input-field"
      type="text"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="inputText()"
      (input)="onNativeInput($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
    />

    <!-- Bouton effacer — visible uniquement si du texte est présent -->
    @if (inputText()) {
      <button class="ac-clear-btn"
              type="button"
              (click)="clearInput($event)"
              aria-label="Effacer">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.27337 14.7266C1.63786 15.0911 2.22881 15.0911 2.5933 14.7266L8 9.31993L13.4067 14.7266C13.7712 15.0911 14.3621 15.0911 14.7266 14.7266C15.0911 14.3621 15.0911 13.7712 14.7266 13.4067L9.31993 8L14.7266 2.5933C15.0911 2.22881 15.0911 1.63786 14.7266 1.27337C14.3621 0.908878 13.7712 0.908878 13.4067 1.27337L8 6.68007L2.5933 1.27337C2.22881 0.908878 1.63786 0.908878 1.27337 1.27337C0.908878 1.63786 0.908878 2.22881 1.27337 2.5933L6.68007 8L1.27337 13.4067C0.908878 13.7712 0.908878 14.3621 1.27337 14.7266Z" fill="#121212"/>
        </svg>
      </button>
    }

  </div>
</div>

<ng-template #dropdownTpl>
  <div class="autocomplete__dropdown" (mousedown)="$event.preventDefault()">

    <!-- Contenu scrollable — scrollbar native masquée -->
    <div class="autocomplete__scroll-content" (scroll)="onContentScroll()">

      @if (filteredOptions().length === 0) {
        <div class="autocomplete__empty">Aucun résultat</div>
      }

      @for (opt of filteredOptions(); track opt.source) {
        @if (!opt.isLeaf) {
          <div class="autocomplete__group"
               [style.padding-left]="(opt.level * 16 + 16) + 'px'">
            {{ opt.label }}
          </div>
        } @else {
          <div class="autocomplete__option"
               [class.autocomplete__option--active]="isActive(opt)"
               [style.padding-left]="(opt.level * 16 + 24) + 'px'"
               role="option"
               (click)="selectOption(opt)"
               (mouseenter)="onOptionHover(opt)">
            <span class="autocomplete__option-label">{{ opt.label }}</span>
            @if (opt.marked) {
              <span class="autocomplete__dot"></span>
            }
          </div>
        }
      }

    </div>

    <!-- Scrollbar custom -->
    <div class="autocomplete__scrollbar-wrapper"
         [style.opacity]="showScrollbar() ? 1 : 0">
      <div class="autocomplete__scrollbar-track"
           (click)="onTrackClick($event)">
        <div class="autocomplete__scrollbar-thumb"
             [style.height.px]="thumbHeight()"
             [style.top.px]="thumbTop()"
             (mousedown)="onThumbMouseDown($event)">
        </div>
      </div>
    </div>

  </div>
</ng-template>